<template>
  <div id="app">
    <IHeader></IHeader>
    <router-view/>
  </div>
</template>

<script>
import IHeader from './components/layouts/Header'
import IFooter from './components/layouts/Footer'
export default {
  name: 'App',
  components: {IFooter, IHeader}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue